/* Error Message For Ring Size */
document.addEventListener('DOMContentLoaded', function() {
  const addToCartButton = document.querySelector('.add-to-cart');
  const checkToRunCode = document.getElementById('product-size--shown');

  if (addToCartButton && checkToRunCode) {
    addToCartButton.addEventListener('click', function(e) {

      const ringSize = document.getElementById('choose-ringSize').value;

      if (!ringSize) {
        const customAlert = document.getElementById('custom-alert');
        customAlert.style.display = 'block';

        customAlert.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        });
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const braceletSizeSelect = document.getElementById('choose-braceletSize');

  if (braceletSizeSelect) {
    // Update the options for Medium size
    function updateOptionsForMedium() {
      const options = [
        { value: "14 / 1", label: "14 / 1" },
        { value: "15 / 2", label: "15 / 2" },
        { value: "16 / 3", label: "16 / 3" },
        { value: "17", label: "17" },
        { value: "18", label: "18" }
      ];
      updateBraceletSizeOptions(options);
    }
  
    // Update the options for Large and Extra Large sizes
    function updateOptionsForLargeOrExtraLarge() {
      const options = [
        { value: "14 / 1", label: "14 / 1" },
        { value: "15 / 2", label: "15 / 2" },
        { value: "16 / 3", label: "16 / 3" },
        { value: "17", label: "17" },
        { value: "18", label: "18" },
        { value: "19", label: "19" },
        { value: "20", label: "20" }
      ];
      updateBraceletSizeOptions(options);
    }
  
    function updateBraceletSizeOptions(options) {
      // Reset to default state
      braceletSizeSelect.innerHTML = '<option disabled selected value="Null">--</option>';
  
      // Add the new options
      options.forEach(option => {
        const optionElement = document.createElement('option');
        optionElement.value = option.value;
        optionElement.textContent = option.label;
        braceletSizeSelect.appendChild(optionElement);
      });
    }
  
    updateOptionsForMedium(); // Initialize on page load to prevent ring sizes from getting slotted into the bracelet size dropdown
    // Event delegation for click events on inputs with a 'value' attribute
    document.addEventListener('click', function (event) {
      const clickedElement = event.target;
  
      if (clickedElement.tagName.toLowerCase() === 'input' && clickedElement.value) {
        switch (clickedElement.value) {
          case 'Medium':
            updateOptionsForMedium();
            break;
          case 'Large':
          case 'Extra Large':
            updateOptionsForLargeOrExtraLarge();
            break;
        }
      }
    });
  
    /* Size Guide Modal */
    const sizeGuideModal = document.getElementById('sizeGuideModal');
    const sizeGuideOpenBtn = document.getElementById('openSizeGuide');
    const sizeGuideCloseBtn = document.getElementById('closeSizeGuide');
  
    sizeGuideOpenBtn.addEventListener('click', () => {
      sizeGuideModal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    });
  
    sizeGuideCloseBtn.addEventListener('click', () => {
      sizeGuideModal.style.display = 'none';
      document.body.style.overflow = '';
    });
  
    sizeGuideModal.addEventListener('click', (e) => {
      if (e.target === sizeGuideModal) {
        sizeGuideModal.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
  }
});